var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.523,
    height: 127.523,
    viewBox: "0 0 127.523 127.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6097",
    "data-name": "Group 6097",
    transform: "translate(-503 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6097-2",
    "data-name": "Group 6097",
    transform: "translate(503 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5151",
    "data-name": "Path 5151",
    d: "M18.693,0A18.693,18.693,0,0,0,0,18.693V127.512H26.912V26.912h100.6V0Z",
    transform: "translate(0 0)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5152",
    "data-name": "Path 5152",
    d: "M101.941,101.941v93.99h75.3a18.693,18.693,0,0,0,18.693-18.693V135.454H135.454v26.912h33.529v6.617H128.853V128.853h67.078V101.941Z",
    transform: "translate(-68.408 -68.408)",
    fill: "#171717"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.804b63802921798bf80ec61112b8d820.svg";
export { ForwardRef as ReactComponent };